import axios from 'axios'

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL || 'https://swap-space-latest.onrender.com',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // Increased timeout to 30 seconds
})
console.log('API Base URL:', process.env.REACT_APP_BASE_API_URL);


// Request interceptor to attach authentication token
api.interceptors.request.use(config => {
  const token = localStorage.getItem('authToken')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Response interceptor for error handling
api.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      console.error(`API Error ${error.response.status}: ${error.config.url}`, error.response.data)

      if (error.response.status === 401) {
        localStorage.removeItem('authToken')
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/login'
        }
      } else if (error.response.status === 403) {
        console.error('Access denied:', error.response.data)
      } else if (error.response.status === 404) {
        console.error('Resource not found:', error.response.data)
      } else if (error.response.status === 500) {
        console.error('Internal server error:', error.response.data)
      }
    } else if (error.request) {
      console.error('No response received:', error.request)
    } else {
      console.error('Request setup error:', error.message)
    }

    return Promise.reject(error)
  }
)

export const getDashboardData = () => {
  return api.get('/dashboard')
}

export const getBrowserViews = () => {
  return api.get('/v1/session/browser-views')
}

export const getDesktopViews = () => {
  return api.get('/v1/session/desktop-views')
}

export const getWorldMap = () => {
  return api.get('/v1/admin/dashboard/world-map')
}

export const getMobileViews = () => {
  return api.get('/v1/session/mobile-views')
}

export const getOtherViews = () => {
  return api.get('/v1/session/other-views')
}

export const getMonthlyPlatformBreakdown = () => {
  return api.get('/v1/session/monthly-platform-breakdown')
}

export const getHourlyPropertyViews = () => {
  return api.get('/v1/session/hourly-property-views')
}

export const getHourlySessions = () => {
  return api.get('/v1/session/hourly-sessions')
}

export const getAllAnalytics = () => {
  return api.get('/v1/session/all')
}

export const getAllSessions = () => {
  return api.get('/v1/session/all')
}

export const getWebsiteMetrics = () => {
  return api.get('/v1/session/website-metrics')
}

export const getAppMetrics = () => {
  return api.get('/v1/session/app-metrics')
}

export const getUserTypeBreakdown = () => {
  return api.get('/v1/session/user-type-breakdown')
}

// KPI Endpoints for Dashboard Stats
export const getKPIData = () => {
  return api.get('/v1/admin/dashboard/kpi')
}

export const getConversionByDevice = () => {
  return api.get('/v1/admin/dashboard/kpi/conversion-by-device')
}

export const getAppDownloads = () => {
  return api.get('/v1/admin/dashboard/kpi/app-downloads')
}

export const getSalesConversionPath = () => {
  return api.get('/v1/admin/dashboard/kpi/sales-conversion-pathway')
}

export const getWebsiteAnalytics = () => {
  return api.get('/v1/admin/dashboard/website-analytics')
}

// Review Endpoints
export const getAllReviews = () => {
  return api.get('/v1/reviews/all')
}

export const getReviewById = (reviewId) => {
  return api.get(`/v1/reviews/${reviewId}`)
}

export const getReviewsAnalytics = () => {
  return api.get('/v1/reviews/analytics')
}

export const markReviewOpened = (reviewId) => {
  return api.patch(`/v1/reviews/${reviewId}/mark-opened`)
}

export const getReviewOpenedStatus = (reviewId) => {
  return api.get(`/v1/reviews/${reviewId}/mark-opened`)
}

export const createReview = (reviewData) => {
  return api.post('/v1/reviews', reviewData)
}

export const updateReview = (reviewId, reviewData) => {
  return api.put(`/v1/reviews/${reviewId}`, reviewData)
}

export const deleteReview = (reviewId) => {
  return api.delete(`/v1/reviews/${reviewId}`)
}

export const flagReview = (reviewId, flagData) => {
  return api.post(`/v1/reviews/${reviewId}/flag`, flagData)
}

export const voteOnReview = (reviewId, voteData) => {
  return api.post(`/v1/reviews/${reviewId}/vote`, voteData)
}

export const getPropertyReviews = (propertyId) => {
  return api.get(`/v1/reviews/property/${propertyId}`)
}

// Survey Response Endpoints
export const getSurveyResponses = (surveyId) => {
  return api.get(`/v1/surveys/${surveyId}/responses`)
}

export const createSurveyResponse = (surveyId, responseData) => {
  return api.post(`/v1/surveys/${surveyId}/responses`, responseData)
}

export const getAllSurveyResponses = () => {
  return api.get('/v1/survey-responses')
}

export const getTotalSurveyResponses = () => {
  return api.get('/v1/survey-responses/total')
}

export const getSurveyResponsesMoodScale = () => {
  return api.get('/v1/survey-responses/mood-scale')
}

export default api